
import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { max } from 'lodash';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_API_KEY;

const SmallMapCard = ({ locations, rounded=false, mapHeight="200px" }) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  
  useEffect(() => {
    if (!map.current && locations.length > 0) {
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/innspiremapbox/clv9b4wyu00p801ph33xi424i',
        center: [locations[0].longitude, locations[0].latitude],
        zoom: 9,
      });
  
      map.current.addControl(new mapboxgl.NavigationControl(), 'top-right');
  
      // Add markers *after* the map has loaded
      map.current.on('load', () => {
        addMarkers();
      });
    } else if (map.current && locations.length > 0) {
      // If map already exists, update markers
      addMarkers();
    }
  
    function addMarkers() {
        // Remove old markers
        map.current?.markers?.forEach(marker => marker.remove());
      
        const bounds = new mapboxgl.LngLatBounds();
      
        const newMarkers = locations.map((loc) => {
          const imageUrl = loc.images?.[0]?.image ;
          const el = document.createElement('div');
          el.className = 'custom-marker';
          el.style.backgroundImage = `url(${imageUrl})`;
          el.style.width = '40px';
          el.style.height = '40px';
          el.style.backgroundSize = 'cover';
          el.style.borderRadius = '50%';
          el.style.border = '2px solid white';
          el.style.boxShadow = '0 0 4px rgba(0,0,0,0.3)';
     
          const marker = new mapboxgl.Marker(el)
            .setLngLat([loc.longitude, loc.latitude])
            .setPopup(new mapboxgl.Popup({ offset: 25 }).setText(loc.name))
            .addTo(map.current);
     
          // Extend bounds to include this marker
          bounds.extend([loc.longitude, loc.latitude]);
     
          return marker;
        });
      
        map.current.markers = newMarkers;
      
        // Fit map to bounds of all markers
        if (!bounds.isEmpty()) {
          map.current.fitBounds(bounds, { padding: 50, maxZoom: 15 });
        }
      }
      
  
    // Cleanup if component unmounts
    return () => {
      if (map.current) {
        map.current.remove();
        map.current = null;
      }
    };
  }, [locations]);
  

  return (
    <div className={`w-full h-full overflow-hidden ${rounded ? 'rounded-xl' : ''}`}
    style={{ display: locations.length === 0 ? 'none' : 'block' }}
    >
    <div
      ref={mapContainer}
      style={{ width: '100%', height: mapHeight }}
    />
    </div>
  );
};

export default SmallMapCard;
